/**
 * Swap the HIPAA release link in an Elementor form to the PDF of the clinic
 * the visitor selects.
 *
 * Config is inlined by lib/functions/hipaa-release.php as
 * window.ccrmHipaaRelease = { map: { <normalised clinic key>: url }, field: 'clinic_name' }.
 * Keys cover each location's H1 title, title, slug and city.
 *
 * Markup: an anchor with class "ccrm-hipaa-link" inside the form (typically in
 * an Acceptance field's text). Optional data-hipaa-field="field_id" overrides
 * which form field drives the swap. The anchor is plain text (no href) until a
 * clinic is selected, and stays plain text when the selected clinic has no
 * PDF of its own. Any href in the markup is only a no-JS placeholder; PHP
 * strips it before output.
 */
(function () {
	var cfg = window.ccrmHipaaRelease || {};
	var map = cfg.map || {};
	var defaultField = cfg.field || 'clinic_name';

	// Mirrors ccrm_hipaa_release_key() in PHP — keep the two in sync.
	function key(value) {
		// ASCII only on purpose: a raw combining-character regex here broke
		// parsing when the file was served without a UTF-8 charset.
		var s = String(value || '').toLowerCase();
		return s.replace(/[^a-z0-9]+/g, '').replace(/^(ccrm)?(fertility)?(of)?/, '');
	}

	function fieldValue(form, id) {
		var els = form.querySelectorAll('[name="form_fields[' + id + ']"], [name="form_fields[' + id + '][]"]');
		var values = [];
		for (var i = 0; i < els.length; i++) {
			var el = els[i];
			if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) {
				continue;
			}
			if (el.tagName === 'SELECT' && el.multiple) {
				for (var j = 0; j < el.options.length; j++) {
					if (el.options[j].selected) {
						values.push(el.options[j].value);
					}
				}
				continue;
			}
			values.push(el.value);
		}
		return values;
	}

	function lookup(values) {
		for (var i = 0; i < values.length; i++) {
			var k = key(values[i]);
			if (k && map[k]) {
				return map[k];
			}
		}
		return '';
	}

	// Elementor gives a select's placeholder option a real value (its label,
	// e.g. " Select clinic name"), so an empty check alone isn't enough.
	function isPlaceholder(value) {
		return /^\s*(select|choose|please|pick)\b/i.test(value);
	}

	function hasSelection(values) {
		for (var i = 0; i < values.length; i++) {
			var v = String(values[i] || '').trim();
			if (v !== '' && !isPlaceholder(v)) {
				return true;
			}
		}
		return false;
	}

	// No href = plain text; browsers render it unlinked and it can't be clicked.
	function setLink(a, url) {
		if (url) {
			a.setAttribute('href', url);
			a.removeAttribute('aria-disabled');
			a.classList.remove('ccrm-hipaa-link--pending');
			a.style.color = '';
			a.style.textDecoration = '';
			a.style.cursor = '';
		} else {
			a.removeAttribute('href');
			a.setAttribute('aria-disabled', 'true');
			a.classList.add('ccrm-hipaa-link--pending');
			a.style.color = 'inherit';
			a.style.textDecoration = 'none';
			a.style.cursor = 'default';
		}
	}

	function update(form) {
		var links = form.querySelectorAll('a.ccrm-hipaa-link');
		for (var i = 0; i < links.length; i++) {
			var a = links[i];
			var id = a.getAttribute('data-hipaa-field') || defaultField;
			var values = fieldValue(form, id);
			// Linked only when a clinic is chosen AND that clinic has its own PDF.
			setLink(a, hasSelection(values) ? lookup(values) : '');
		}
	}

	function updateAll() {
		var forms = document.querySelectorAll('form.elementor-form');
		for (var i = 0; i < forms.length; i++) {
			update(forms[i]);
		}
	}

	document.addEventListener('change', function (e) {
		var form = e.target && e.target.closest ? e.target.closest('form.elementor-form') : null;
		if (form) {
			update(form);
			// The clinic list is rebuilt when the location changes; re-read after
			// that script has run.
			setTimeout(function () { update(form); }, 0);
		}
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', updateAll);
	} else {
		updateAll();
	}

	// Forms inside Elementor popups are injected after load.
	if (window.jQuery) {
		window.jQuery(document).on('elementor/popup/show', updateAll);
	}
})();
